/**
 * (c) 智汇考题
 */

let url = 'http://education_api.mambaxin.com';
//let url = 'http://backend.education.com';

export default {
    url: url
}